var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(message){return _c('div',{key:message.id},[_c('SnackBarItem',{attrs:{"message":message}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }